import { useStoreDollHouseMap } from "../../store";
import { useEffect, useState } from "react";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";

export default function NomadHotspots() {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      NomadHighlightPoiStore: state.NomadHighlightPoiStore,
      resetNomadHighlightPOI: state.resetNomadHighlightPOI,
      sourcePoidSelected: state.sourcePoidSelected,
      destinationPoidSelected: state.destinationPoidSelected,
    }),
    shallow
  );

  const [destinationPoidSelected, setdestconventionActive] = useState("");
  const [sourceconventionActive, setsourceconventionActive] = useState("");

  /*
   *BELLAGIO EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    if (dollhouseStore.sourcePoidSelected === "") {
      setsourceconventionActive("");
    }

    if (dollhouseStore.sourcePoidSelected === "no_mad_elevators") {
      setsourceconventionActive("active-poi-selection");
    }
  }, [dollhouseStore.sourcePoidSelected]);

  useEffect(() => {
    if (dollhouseStore.destinationPoidSelected === "") {
      setdestconventionActive("");
    }

    if (dollhouseStore.destinationPoidSelected === "no_mad_elevators") {
      setdestconventionActive("active-poi-selection");
    }
  }, [dollhouseStore.destinationPoidSelected]);
  /*
   *BELLAGIO EXIST Route POI HIGHLIGHTING [end]
   */

  /*
   *NOMAD NOT EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    if (dollhouseStore.NomadHighlightPoiStore === "") {
      document.querySelectorAll(".poi-hover").forEach((val) => {
        val.classList.remove("active-poi");
      });
    } else {
      document.querySelectorAll(".poi-hover").forEach((val) => {
        val.classList.remove("active-poi");
      });

      if (document.getElementById(dollhouseStore.NomadHighlightPoiStore)) {
        document
          .getElementById(dollhouseStore.NomadHighlightPoiStore)
          .classList.add("active-poi");
      }
    }
  }, [dollhouseStore.NomadHighlightPoiStore]);
  /*
   *NOMAD NOT EXIST Route POI HIGHLIGHTING [end]
   */

  return (
    <>
      <g transform="translate(743.321 2036.599)">
        <path
          className="poi-hover"
          id="park_mgm_no_mad_lobby"
          d="M-7459.884-10992.609l58.926,24.847-49.233,105.244-57.875-25.517Z"
          transform="translate(7705.173 10996.51)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "park_mgm_no_mad_lobby");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("park_mgm_no_mad_lobby");
            showPopupWithContent(e, "park_mgm_no_mad_lobby");
          }}
          onMouseLeave={(e) => {
            animationEnd("park_mgm_no_mad_lobby");
            hidePopup("park_mgm_no_mad_lobby");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("park_mgm_no_mad_lobby");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
          fill="rgba(255,255,255,0.06)"
        />

        <path
          className="poi-hover"
          id="no_mad_library"
          d="M1288.722,3817.549l170.2,71.827-30.132,69.253-17.356,12.345-159.263-67.1Z"
          transform="translate(-1248.269 -3576.05)"
          fill="rgba(255,255,255,0.06)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "no_mad_library");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("no_mad_library");
            showPopupWithContent(e, "no_mad_library");
          }}
          onMouseLeave={(e) => {
            animationEnd("no_mad_library");
            hidePopup("no_mad_library");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("no_mad_library");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
        />
        {/* <path
          className="poi-hover"
          id="no_mad_bar"
          d="M-7755.583-10687.143l27.285-64.29,171.5,71.191-27.421,63.075Z"
          transform="translate(7807.373 10901.328)"
          fill="rgba(255,255,255,0.06)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "no_mad_bar");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("no_mad_bar");
            showPopupWithContent(e, "no_mad_bar");
          }}
          onMouseLeave={(e) => {
            animationEnd("no_mad_bar");
            hidePopup("no_mad_bar");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("no_mad_bar");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
        /> */}

        <path
          id="no_mad_elevators"
          className={`poi-hover `}
          d="M-7230.567-10798.117l25.606-9.247,29.551,16.018-.02,40.354-21.387,15.725-49.954-21.67Z"
          transform="translate(7599.804 10921.809)"
          fill="rgba(255,255,255,0.03)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "no_mad_elevators");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("no_mad_elevators");
            showPopupWithContent(e, "no_mad_elevators");
          }}
          onMouseLeave={(e) => {
            animationEnd("no_mad_elevators");
            hidePopup("no_mad_elevators");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("no_mad_elevators");
            dollhouseStore.resetNomadHighlightPOI("");
          }}
        />
      </g>
    </>
  );
}
